export const ColorMap = new Map<string, string>([
  ["Sick AG", "#007ec2"],
  ["Atlas Copco", "#09C"],
  ["Lizergy", "#74B727"],
  ["Azeti", "#dd052d"],
]);
